module.exports = __webpack_public_path__ + "static/media/scan_id_card_picture.2bcf8222.png";